import { Component, OnInit, OnChanges , Input, SimpleChanges } from '@angular/core';

declare var bootstrap: any;

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, OnChanges  {
  @Input() Type = "";
  @Input() View = false;
  @Input() Message = "";

  constructor() { }

  ngOnInit(): void {
    this.Show();
  }

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['View'];
    if(change.currentValue){
      this.Show();
    }
  }

  Show(){
    const successToast = document.getElementById('successToast')
    const failToast = document.getElementById('failToast')
    if (this.View) {
      const toast = this.Type === "success" ? new bootstrap.Toast(successToast) : new bootstrap.Toast(failToast);
      toast.show();
    }
  }
}
